import { snakeCase } from "lodash"
import { comparisionChartOptions, spendVBudgetedChartOptions } from "../src/chart_defaults"
import { spendVFeesChartOptions } from "../src/chart_defaults"
import DateRangeChanger from "../src/date_range_changer"
import { updateSpendVBudgetedTable, updateSpendVFeesTable, updateComparisonTable } from "../src/reports"
import { downloadLink } from "../src/tools"

const SPEND_V_BUDGETED_CHART_CONTEXT_ID = 'spend-v-budgeted-chart'
const SPEND_V_FEES_CHART_CONTEXT_ID = 'spend-v-fees-chart'
const COMPARISON_CHART_CONTEXT_ID = 'six-month-view-chart'
let spendVBudgetedDateRange, spendVBudgetedChart, spendVFeesChart, sixMonthViewDateRange, comparisonChart
let spendVBudgetedRequest, spendVFeesRequest, comparisonRequest

jQuery(document).ready(function () {
  if (!jQuery(".budget-page-content").length) return
  bindBudgetPage()
})

const bindBudgetPage = function() {
  bindSnapshotCard()
  bindComparisonCard()
}

function bindSnapshotCard() {
  spendVBudgetedDateRange = new DateRangeChanger({parentId: '#spend-v-budgeted-simple-refine'})

  new CraftySelect2({
    select: jQuery(".budget-page-content #budget_id"),
    onSelect: fetchSnapShotReports,
    onUnselect: fetchSnapShotReports,
  }).init()

  initializeSpendVBudgetedChart()
  intitalizeSpendVFeesBreakdownChart()
  bindSnapshotDateFilterButtons()
  bindSnapShotDetailLinks()
  bindSnapshotDownload()
}

function bindComparisonCard() {
  sixMonthViewDateRange = new DateRangeChanger({parentId: '#six-month-view-simple-refine'})
  bindComparisonDateFilterButtons()

  new CraftySelect2({
    select: jQuery(".budget-page-content #comparison_budget_id"),
    onSelect: fetchComparisionReport,
    onUnselect: fetchComparisionReport,
  }).init()

  initializeComparisonChart()
  bindComparisonTypeToggle()
  bindComparisonDownload()
}

function bindSnapShotDetailLinks() {
  jQuery('.budget-page-content .snapshot-link').on('click', function(e) {
    e.stopPropagation()
    const baseUrl = jQuery(this).data('link')
    const data = getSnapshotParams()
    const selected = jQuery(".budget-page-content #budget_id").val()
    const params = $.param({ ...data, selected })
    const fullPath = baseUrl + '?' + params
    window.location.href = fullPath 
  })
}

function fetchSnapShotReports() {
  const data = getSnapshotParams()
  const url = jQuery("#spend-v-budgeted-wrapper").data("link")
  fetchSpendVBudgetedReport(url, { ...data, report_name: "spend_v_budgeted" } )
  fetchSpendVFeesBreakdownReport(url, { ...data, report_name: "spend_v_fees_breakdown" } )
  fetchBudgetStrategyStatus(data['budget_id'] ? { budget_id: data['budget_id'] } : { budget_id: null })
}

function bindComparisonTypeToggle() {
  $(`#six-month-view-simple-refine input[type="radio"][name="view-type-toggle"]`).change(function() {
    jQuery(this).prop("checked", true)
    fetchComparisionReport()
  })
}

function fetchSpendVBudgetedReport(url, data) {
  spendVBudgetedChart.reset()
  spendVBudgetedRequest = jQuery.ajax({
    url,
    type: "GET",
    dataType: "json",
    data,
    success: function(res) {
      const ctx = document.getElementById(SPEND_V_BUDGETED_CHART_CONTEXT_ID)
      ctx.style.display = 'block'
      const { labels, datasets } = res.data
      spendVBudgetedChart.data = { labels, datasets }
      spendVBudgetedChart.update()
      const $table = $('#spend-v-budgeted-table')
      updateSpendVBudgetedTable($table, {labels, datasets})
    },
    beforeSend: function () {
      if (spendVBudgetedRequest != null) {
        spendVBudgetedRequest.abort()
      }
    },
    complete: function () {
      spendVBudgetedRequest = null
    },
  })
}

function fetchComparisionReport() {
  const data =  { ...getComparisonParams(), report_name: 'comparison_six_month' }
  const url = jQuery("#spend-v-budgeted-wrapper").data("link")

  comparisonChart.reset()
  comparisonRequest = jQuery.ajax({
    url,
    type: "GET",
    dataType: "json",
    data,
    success: function(res) {
      const ctx = document.getElementById(COMPARISON_CHART_CONTEXT_ID)
      ctx.style.display = 'block'
      const { labels, datasets } = res.data
      comparisonChart.data = { labels, datasets }
      comparisonChart.update()
      const $table = jQuery('#comparison-table')
      updateComparisonTable($table, {labels, datasets})
    },
    beforeSend: function () {
      if (comparisonRequest != null) {
        comparisonRequest.abort()
      }
    },
    complete: function () {
      comparisonRequest = null
    },
  })
}

function fetchSpendVFeesBreakdownReport(url, data) {
  spendVFeesChart.reset()
  spendVFeesRequest = jQuery.ajax({
    url,
    type: "GET",
    dataType: "json",
    data,
    success: function(res) {
      const ctx = document.getElementById(SPEND_V_FEES_CHART_CONTEXT_ID)
      ctx.style.display = 'block'
      const { labels, datasets } = res.data
      spendVFeesChart.data = { labels, datasets }
      spendVFeesChart.update()
      const $table = $('#spend-v-fees-table')
      updateSpendVFeesTable($table, { labels, datasets })
    },
    beforeSend: function () {
      if (spendVFeesRequest != null) {
        spendVFeesRequest.abort()
      }
    },
    complete: function () {
      spendVFeesRequest = null
    },
  })
}

function getSnapshotParams() {
  const { from_range, to_range, group } = spendVBudgetedDateRange.getValues()
  const $selectedBudget = jQuery(".budget-page-content #budget_id")
  const selectedValue = $selectedBudget.val()
  const [row_type, id] = selectedValue.split("-")
  return { [`${snakeCase(row_type)}_id`]: id, row_type, to_range, group, from_range }
}

function getComparisonParams() {
  const { from_range, to_range, group } = sixMonthViewDateRange.getValues()
  const $selectedBudget = jQuery(".budget-page-content #comparison_budget_id")
  const comparison_type = $(`#six-month-view-simple-refine input[type="radio"][name="view-type-toggle"]:checked`).val()
  const selectedValue = $selectedBudget.val()
  const [row_type, id] = selectedValue.split("-")
  return { [`${snakeCase(row_type)}_id`]: id, row_type, to_range, group, from_range, comparison_type }
}

function bindSnapshotDateFilterButtons() {
  jQuery('#spend-v-budgeted-simple-refine').find('.date-back, .date-forward, .date-group-input').on('dateRangeChanged', function (e) {
    e.stopPropagation
    fetchSnapShotReports()
  })
}

function bindSnapshotDownload() {
  jQuery('.snapshot-download-link').click(downloadSnapshotReport)
}

function bindComparisonDownload() {
  jQuery('.comparison-six-month-download-link').click(downloadComparisonReport)
}

function downloadSnapshotReport(e) {
  e.preventDefault()
  const snapshotData = getSnapshotParams()
  const link = jQuery(this).data('link')

  if (snapshotData && !snapshotData.budget_id && !snapshotData.budget_group_id) return
  downloadLink(link, snapshotData)
}

function downloadComparisonReport(e) {
  e.preventDefault()
  const { comparison_type, ...comparisonData } = getComparisonParams()
  const link = jQuery(this).data('link')

  if (comparisonData && !comparisonData.id && !comparisonData.row_type) return
  downloadLink(link, comparisonData)
}

function bindComparisonDateFilterButtons() {
  jQuery('#six-month-view-simple-refine').find('.date-back, .date-forward, .date-group-input').on('dateRangeChanged', function (e) {
    e.stopPropagation
    fetchComparisionReport()
  })
}

function initializeComparisonChart() {
  const ctx = document.getElementById(COMPARISON_CHART_CONTEXT_ID)
  if (ctx === null) return
  ctx.style.display = 'none'
  comparisonChart = new Chart(ctx, {
    type: 'line',
    options: comparisionChartOptions,
  })
  fetchComparisionReport()
}

function initializeSpendVBudgetedChart() {
  const ctx = document.getElementById(SPEND_V_BUDGETED_CHART_CONTEXT_ID)
  if (ctx === null) return
  ctx.style.display = 'none'
  spendVBudgetedChart = new Chart(ctx, {
    type: 'bar',
    options: spendVBudgetedChartOptions,
  })
}

function intitalizeSpendVFeesBreakdownChart() {
  const ctx = document.getElementById(SPEND_V_FEES_CHART_CONTEXT_ID)
  if (ctx === null) return
  ctx.style.display = 'none'
  spendVFeesChart = new Chart(ctx, {
    type: 'pie',
    options: spendVFeesChartOptions,
  })
  fetchSnapShotReports()
}

function displayRequestBudgetModal(inProd) {
  try {
    const $modalContainer = jQuery('#budget-request-modal')
    $modalContainer.modal('show')
    const portalId = inProd ? 2517383 : 24281123
    const formId = inProd ? 'fb345b0f-8cbd-4047-abdd-b1c57f77b40f' : '078263af-e849-4b7a-83cc-18c9271f5d34'
    hbspt.forms.create({
      region: "na1",
      portalId,
      target: '#budget-request-modal .modal-body',
      formId,
      onFormSubmitted: function() {
        $modalContainer.modal('hide')
        showToast("Budget has been requested", 'success')
      },
     })
  } catch (error) {
    console.error(error)
    alert("There was an error loading the form, please reach out to the team for support.")
  }
}

function fetchBudgetStrategyStatus(params) {
  const $container = jQuery('#budget-strategy-container')
  const url = $container.data('link') + '?' + jQuery.param(params)

  jQuery.ajax({
    url,
    type: 'GET',
    dataType: 'script',
  })
}

window.displayRequestBudgetModal = displayRequestBudgetModal
window.bindBudgetPage = bindBudgetPage
